import { Box, styled } from "@material-ui/core";
import {
  EPOCUS_BORDER,
  EPOCUS_PRIMARY,
  EPOCUS_SELECTED_BG,
  EPOCUS_TEXT_SECONDARY,
  EPOCUS_WHITE,
  rem,
} from "../../../_lib/epocus-palette";
import {
  AGREEMENT_COLORS,
  AGREEMENT_LABELS,
  SELECTABLE_AGREEMENTS,
  type SelectableAgreement,
} from "../../../_lib/review-agreement";

const SegmentedTrack = styled(Box)({
  display: "flex",
  gap: 4,
  padding: 4,
  borderRadius: 12,
  backgroundColor: EPOCUS_SELECTED_BG,
});

const Segment = styled("button")({
  flex: 1,
  minHeight: 52,
  padding: "8px 6px",
  border: "none",
  borderRadius: 9,
  cursor: "pointer",
  fontSize: rem(13),
  fontWeight: 600,
  lineHeight: 1.25,
  backgroundColor: "transparent",
  color: EPOCUS_TEXT_SECONDARY,
  "&:focus-visible": {
    outline: `2px solid ${EPOCUS_PRIMARY}`,
    outlineOffset: 2,
  },
  "&:disabled": { cursor: "default" },
});

export const AgreementControl: FC<{
  value: SelectableAgreement | null;
  onChange: (value: SelectableAgreement) => void;
  disabled?: boolean;
}> = ({ value, onChange, disabled = false }) => (
  <SegmentedTrack role="radiogroup" aria-label="Agree with findings?">
    {SELECTABLE_AGREEMENTS.map((agreement) => {
      const selected = value === agreement;

      return (
        <Segment
          key={agreement}
          type="button"
          role="radio"
          aria-checked={selected}
          disabled={disabled}
          onClick={() => onChange(agreement)}
          style={
            selected
              ? {
                  backgroundColor: AGREEMENT_COLORS[agreement],
                  color: EPOCUS_WHITE,
                  boxShadow: `0 0 0 1px ${EPOCUS_BORDER}`,
                }
              : undefined
          }
        >
          {AGREEMENT_LABELS[agreement]}
        </Segment>
      );
    })}
  </SegmentedTrack>
);
